import { render, staticRenderFns } from "./boton.vue?vue&type=template&id=45a1b41d&scoped=true&"
import script from "./boton.vue?vue&type=script&lang=js&"
export * from "./boton.vue?vue&type=script&lang=js&"
import style0 from "./boton.vue?vue&type=style&index=0&id=45a1b41d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a1b41d",
  null
  
)

export default component.exports